var map = {
	"./clock/index.tsx": 5052,
	"./note/index.tsx": 3035,
	"./search/index.tsx": 6570,
	"widgets/clock/index.tsx": 5052,
	"widgets/note/index.tsx": 3035,
	"widgets/search/index.tsx": 6570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6177;